<div *ngIf="isOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="relative bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col mx-4">
        <div *ngIf="loading" class="absolute inset-0 bg-white/60 z-50 flex items-center justify-center">
            <app-loading></app-loading>
        </div>

        <div class="flex justify-between items-center p-6 border-b">
            <h1 class="font-bold text-2xl">Importar procedimentos</h1>
            <div *ngIf="!loading" (click)="close()" class="cursor-pointer hover:text-neutral-900">
                <fa-icon [icon]="faTimes" size="lg"></fa-icon>
            </div>
        </div>

        <div class="p-6">
            <label class="inline-flex items-center px-4 py-2 bg-gray-200 rounded cursor-pointer" [class.opacity-50]="uploading || loading">
                <input type="file" accept=".csv,.xlsx,.xls" (change)="onFileSelected($event)" class="hidden" [disabled]="uploading || loading">
                <span *ngIf="!fileName">Anexar arquivo</span>
                <span *ngIf="fileName">{{ fileName }}</span>
            </label>

            <button *ngIf="!uploading && fileName && !loading" (click)="startUpload()" type="button" class="ml-3 px-4 py-2 bg-blue-600 text-white rounded">
                Enviar
            </button>
        </div>

        <div *ngIf="(uploading || uploadProgress > 0) && !loading" class="p-6">
            <div class="w-full bg-gray-200 rounded h-4 overflow-hidden">
                <div class="bg-blue-600 h-4 transition-all" [style.width.%]="uploadProgress"></div>
            </div>
            <div class="text-sm mt-2">{{ uploadProgress }}%</div>
        </div>

        <div *ngIf="successMessage" class="p-6">
            <div class="text-green-700 bg-green-100 p-4 rounded">
                {{ successMessage }}
            </div>
        </div>

        <div *ngIf="apiMessage" class="p-6">
            <div class="text-red-700 bg-red-100 p-4 rounded">
                <strong>{{ apiMessage }}</strong>
            </div>
        </div>

        <div *ngIf="apiErrors?.length" class="p-6">
            <h3 class="font-semibold mb-2">Erros encontrados</h3>
            <ul class="list-disc pl-5 space-y-2 text-sm">
                <li *ngFor="let e of apiErrors">
                    <span *ngIf="e.line">Linha {{ e.line }}:</span>
                    {{ e.description || (e.code ? e.code : '') }}
                </li>
            </ul>
        </div>

    </div>
</div>